export const APIResponse = "APIRES";
export const APIStats = "APIStats";
export const APIError = "APIError";


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js